import Axios from "axios";
import { API_URL } from "../config";
import { Toastify } from "@/utils/toast";
import { store } from "@/store";
import { updateUserConnected } from "@/store/reducers/user/user.action";

// setuo dispatch
const dispatch = store.dispatch;

export const axios = Axios.create({
  baseURL: API_URL,
  timeout: 120000,
});

axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const message = error.response?.data?.message || error.message;

    console.log(error.response?.status);
    console.log(error.response?.statusText);

    if (
      error.response?.status === 401 &&
      error.response.statusText === "UNAUTHORIZED"
    ) {
      let user: any;
      dispatch(updateUserConnected(user));
      // window.location.reload();
      window.location.href = "/auth/sign-in";
      // if(getCurrentUserInfo()) {
      //   const refreshToken = getCurrentUserInfo()?.refreshToken;
      //   try {
      //     const newToken: any = await refreshAccessToken({
      //       refresToken: refreshToken
      //     })
      //     if(newToken) {
      //       setAuthToken(newToken.data?.accessToken);
      //     }
      //     error.config.headers['Authorization'] = newToken.data?.accessToken;
      //     return axiosAdministration.request(error.config);
      //   } catch (e) {
      //   }
      // }
    } else {
      Toastify("error", message);
    }

    console.log(message);

    return Promise.reject(error);
  }
);
